import { useLocation, Navigate, Outlet } from "react-router-dom";
// import Cookies from 'js-cookie';
import { useSelector } from "react-redux";
const RequireAuth = ({ allowedRoles }) => {
   const loginreducer = useSelector((state) => state.reducers.loginreducer.loginDetails);
   //const token = Cookies.get("jwtToken");
   const location = useLocation();
   let Roles = []
   if (loginreducer?.userType === "emp") {
      Roles = [8]
   }
   else if (loginreducer?.userType === "user") {
      Roles = [1]
   }
   return (

      Roles?.find(role => allowedRoles?.includes(role)) ? <Outlet /> :
         <Navigate to="/unauthorized" state={{ from: location }} replace />
   );
}

export default RequireAuth;